var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uploadItem" }, [
    _c(
      "div",
      {
        staticClass: "image_poster",
        style: { width: _vm.width + "px", height: _vm.height + "px" },
      },
      [
        _vm.status === 1
          ? _c(
              "div",
              [
                _c("div", [
                  _vm._v("上传中(" + _vm._s(_vm.authProgress) + "%)"),
                ]),
                _c("el-progress", {
                  attrs: { "show-text": false, percentage: _vm.authProgress },
                }),
              ],
              1
            )
          : _vm.status === 2
          ? _c(
              "div",
              {
                staticClass: "image_poster",
                style: { width: _vm.width + "px", height: _vm.height + "px" },
                on: {
                  mouseenter: function ($event) {
                    _vm.alignUploadShow = true
                  },
                  mouseleave: function ($event) {
                    _vm.alignUploadShow = false
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-error",
                  staticStyle: { color: "#f53f3f", "font-size": "24px" },
                }),
                _c("div", { staticClass: "addimag_icon_error" }, [
                  _vm._v("上传失败"),
                ]),
                _c("transition", { attrs: { name: "slide" } }, [
                  _vm.alignUploadShow
                    ? _c(
                        "div",
                        { staticClass: "alignUploadShow" },
                        [
                          _c("svg-icon", {
                            staticClass: "alignUploadIcon",
                            attrs: { "icon-class": "alignUploadShow" },
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("again")
                                },
                              },
                            },
                            [_vm._v("重新上传")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _vm.status === 3
          ? _c(
              "div",
              {
                staticClass: "image_poster",
                style: { width: _vm.width + "px", height: _vm.height + "px" },
              },
              [
                _vm._t(
                  "uploadShow",
                  function () {
                    return [
                      _c("uploadShow", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: {
                          index: _vm.index,
                          width: _vm.width,
                          height: _vm.height,
                          "upload-show-arr": _vm.uploadShowArr,
                          disabled: _vm.disabled,
                          accept: _vm.accept,
                          "before-upload": _vm.beforeUpload,
                          url: _vm.url,
                        },
                        on: {
                          onClick: (res) => _vm.$emit("onClick", res),
                          upload: (obj) => _vm.$emit("upload", obj),
                        },
                      }),
                    ]
                  },
                  { row: _vm.url }
                ),
              ],
              2
            )
          : _vm.status === 4
          ? _c(
              "div",
              {
                staticClass: "image_poster",
                style: { width: _vm.width + "px", height: _vm.height + "px" },
                on: {
                  mouseenter: function ($event) {
                    _vm.alignUploadShow = true
                  },
                  mouseleave: function ($event) {
                    _vm.alignUploadShow = false
                  },
                },
              },
              [_c("div", [_vm._v("解析中(" + _vm._s(_vm.authProgress) + "%)")])]
            )
          : _vm.status === 5
          ? _c(
              "div",
              {
                staticClass: "image_poster",
                style: { width: _vm.width + "px", height: _vm.height + "px" },
                on: {
                  mouseenter: function ($event) {
                    _vm.alignUploadShow = true
                  },
                  mouseleave: function ($event) {
                    _vm.alignUploadShow = false
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-error",
                  staticStyle: { color: "#f53f3f", "font-size": "24px" },
                }),
                _vm.errTips
                  ? _c("div", { staticClass: "addimag_icon_error" }, [
                      _vm._v(_vm._s(_vm.errTips)),
                    ])
                  : _vm._e(),
                _c(
                  "transition",
                  { attrs: { name: "slide" } },
                  [
                    _vm.alignUploadShow
                      ? _c(
                          "el-upload",
                          {
                            ref: "upload",
                            staticClass: "alignUploadShow",
                            attrs: {
                              action: "#",
                              limit: 1,
                              accept: _vm.accept,
                              "before-upload": _vm.beforeUpload,
                              "http-request": _vm.upload,
                              "show-file-list": false,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "alignUploadShow" },
                              [
                                _c("svg-icon", {
                                  staticClass: "alignUploadIcon",
                                  attrs: { "icon-class": "alignUploadShow" },
                                }),
                                _c("div", { staticClass: "pointer" }, [
                                  _vm._v("重新选择"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }